var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pr-1 pl-1"},[_c('div',{staticClass:"no-gutters mt-1 mb-2 ml-3 mr-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"parameter-box"},[_c('h4',[_vm._v(_vm._s(_vm.position))]),_c('div',{staticClass:"parameter-name"},[_vm._v("Current position")])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }